// File: km-pod-interface.js
// Author: King & McGaw (web@kingandmcgaw.com)
// Requirements:
//    jQuery (included by theme.liquid)
//      - current version 2.2.4 (out of date/vulnerable) see: https://snyk.io/test/npm/jquery/2.2.4
//    lodash.js (included by product.kmpod.liquid)
//      - current version 4.17.15 (up to date as of 20/10/2021)
//      - https://lodash.com/docs/4.17.15
//
// Description:
//    This file runs after Shopify option_selection.js does it's magic
//    To start, a single <select> is output to the html from product.kmpod.liquid
//    option_selection.js is a Shopify lib that converts that into 3 individual <select>s based on the available options
//    Finally this script replaces the 3rd <select> with a list of frame option links
//
// NB: even though this is an `object`, it does not maintain state of any kind. It's just a bag of namespaced functions.
// It also uses 3 global variables (yuk). see product-kmpod.liquid.

window.KMPod = {
  frameOptions: {
    none: {
      image: 'https://img.kingandmcgaw.com/i/frames/no_frame.jpg',
      title: 'No frame',
      description: 'No frame'
    },
    black: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880229.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Black painted ash box',
      description: 'Hand-painted solid ash showing the grain of the wood'
    },
    natural: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880232.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Natural oak box',
      description: 'Solid wood finished with an oak veneer'
    },
    white: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880231.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'White painted ash box',
      description: 'Hand-painted solid ash showing the grain of the wood'
    },
    gold: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880242.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Gold cushion',
      description: 'Solid wood with a painted gilt finish'
    }
  },

  wallColours: ['#f3f2f1', '#6d6f73', '#e4dcc6', '#ccd2c4', '#a8b1bf', '#5D6553', '#2D384A'],

  initialize: function () {
    KMPod.generateFrameOptions()
    KMPod.generateWallColours()
  },

  generateFrameOptions: function () {
    // console.log('generateFrameOptions...')
    var frameOptionHtml = _.map(window.productVariants, function (variant) {
      var podMedia = variant.option1
      var podSize = variant.option2
      var podLabel = variant.option3
      var frame = KMPod.frameOptions[podLabel]

      return `<a class="frame-thumb"
        onclick="KMPod.selectFrame('${podLabel}');return false;"
        href="?variant=${variant.id}"
        data-variant-id="${variant.id}"
        data-pod-media="${podMedia}"
        data-pod-size="${podSize}"
        data-pod-label="${podLabel}"
        title="${podMedia} / ${podSize} / ${podLabel} frame"
        ><img src="${frame.image}" alt="${frame.title}"></a>`
    })

    // HACK: picker array is reversed to show "no frame" option last
    // frameOptionHtml.reverse()

    $('.pod-frame-options')
      .html(`<div class="frame-options">${frameOptionHtml.join('\n')}</div><div id="frame-description"></div>`)
      .show()
  },

  generateWallColours: function () {
    // console.log('Wall colours')
    var pickerHtml = _.map(KMPod.wallColours, function (c) {
      return `<a
          onclick="KMPod.selectWallColour('${c}');return false;"
          style="background-color:${c}">
        </a>`
    })

    $('#kmpod-colour-picker').html(
      pickerHtml.join('\n') +
        `<div> <label htmlFor="favcolour" style="font-size: 75%">Your colour</label> <input type="color" id="favcolour" name="favcolour" value="{$colour}"> </div>`
    )

    $('#favcolour').change(function (e) {
      var colour = e.target.value
      // only store if we have permission to
      if (document.cookie.indexOf('_shopify_m=persistent') !== -1) window.localStorage.setItem('favcolour', colour)
      KMPod.selectWallColour(colour)
    })
  },

  selectWallColour: function (colour) {
    if (KMPod.isCanvas()) return
    $('#kmpod-image').css('backgroundColor', colour)
  },

  filterFrameOptions: function (selectedVariantId) {
    // console.log('filterFrameOptions', selectedVariantId)
    var selectedMedia = $('select[data-index=option1]').val()
    var selectedSize = $('select[data-index=option2]').val()
    var selectedFrame = $('select[data-index=option3]').val()

    // Hide all variant options
    $('[data-variant-id]').hide()

    // Then show options for selected media & size
    $(`[data-pod-media='${selectedMedia}'][data-pod-size='${selectedSize}']`).show()

    $('[data-variant-id]').removeClass('selected')
    $(`[data-variant-id="${selectedVariantId}"]`).toggleClass('selected')

    $('#frame-description').html(KMPod.isCanvas() ? '' : KMPod.frameOptions[selectedFrame].description)
    if (KMPod.isCanvas() || selectedFrame === 'none') {
      $('#kmpod-image').css('backgroundColor', '#fff')
      $('#kmpod-colour-picker').hide()
      $('#kmpod-image-attribution').hide()
    } else {
      if ($('#kmpod-image').css('backgroundColor') === 'rgb(255, 255, 255)')
        KMPod.selectWallColour(KMPod.wallColours[0])
      $('#kmpod-colour-picker').show()
      $('#kmpod-image-attribution').show()
    }
    var backgroundSizes = {
      small: '45%',
      medium: '40%',
      large: '35%',
      'extra large': '30%'
    }
    $('#kmpod-image').css('background-size', backgroundSizes[selectedSize])
  },

  // This function must always return a variant
  selectVariant: function (variant) {
    // console.log('selectVariant', variant)
    $('select[data-index=option3]').hide()

    // If for some reason a variant is not available, disable the buy button
    if (variant && variant.available === false) {
      $('#AddToCart').prop('disabled')
      return variant
    }

    // If variant is null then the customer probably chose a combination of options that doesn't exist
    // ie. canvas with a frame or extra-small canvas etc.
    if (null === variant || undefined === variant) {
      if (KMPod.isCanvas()) {
        // If canvas was chosen, try to find a suitable replacement
        $('select[data-index=option3]').val('none')

        var replacementVariant = KMPod.findReplacement()
        if (replacementVariant) {
          return KMPod.selectVariant(replacementVariant)
        }
      }

      // If not canvas or replacement couldn't be found, default to first variant
      // We think this is better than disabling the buy button and making the customer wonder what went wrong
      return KMPod.selectVariant(window.productVariants[0])
    }

    // sanity check. this check probably isn't necessary
    if (KMPod.isVendorKmg(window.product)) {
      KMPod.filterFrameOptions(variant.id)
      KMPod.updatePageDescription(variant.id)
      $('#productSelect-kmpod-product-template').val(variant.id)
    }

    return variant
  },

  selectFrame(podLabel) {
    $('#frame-description').html(KMPod.frameOptions[podLabel].description)
    // $('select[data-index=option3]').val(podLabel).trigger('change')
    $('select[data-index=option3]').val(podLabel)
    document.getElementById('SingleOptionSelector-2').dispatchEvent(new Event('change'))
  },

  updatePageDescription: function (variant_id) {
    var metaFields = window.variantMetafields[variant_id]
    var productDimensionsCm = metaFields['product-dimensions-cm']
    var imageDimensionsCm = metaFields['image-dimensions-cm']
    var productDescription = metaFields['product-description']

    var productSummary = []
    productSummary.push(KMPod.toTitleCase(productDescription))

    var productDimensionsHtml = ''
    var imageDimensionsHtml = ''
    if (metaFields['product-height']) {
      productDimensionsHtml = `Product size: ${metaFields['product-height'].value} x ${metaFields['product-width'].value} cm`
      imageDimensionsHtml = `Image size: ${metaFields['image-height'].value} x ${metaFields['image-width'].value} cm`
    } else {
      productDimensionsHtml = `Product size: ${metaFields['product-dimensions-cm']}`
      imageDimensionsHtml = `Image size: ${metaFields['image-dimensions-cm']}`
    }
    productSummary.push(productDimensionsHtml)
    productSummary.push(imageDimensionsHtml)

    $('#km-product-summary').remove()
    var html = '<div id="km-product-summary" class="km-product-summary">' + productSummary.join('<br>') + '</div>'
    $('.pod-frame-options').append(html)

    var selectedMedia = $('select[data-index=option1]').val()
    var selectedFrame = $('select[data-index=option3]').val()
    var selected =
      selectedMedia === 'art print' ? (selectedFrame === 'none' ? 'no frame' : selectedMedia) : selectedMedia
    $('#kmpod-image')
      .removeClass('unstretched-canvas')
      .removeClass('stretched-canvas')
      .removeClass('art-print')
      .addClass(selected.replace(' ', '-'))
  },

  isVendorKmg: function (product) {
    if (product && product.vendor) {
      return product.vendor.match(/king.*mcgaw/i)
    } else {
      throw 'Product is missing. Cannot continue.'
    }
  },

  toTitleCase: function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  },

  isCanvas: function () {
    return $('select[data-index=option1]')
      .val()
      .match(/canvas/)
  },

  findReplacement: function () {
    var productType = $('select[data-index=option1]').val()
    var productSize = $('select[data-index=option2]').val()

    return _.find(productVariants, function (variant) {
      return variant.option1 == productType && variant.option2 == productSize
    })
  }
}
